import * as angular from 'angular';
import * as moment from 'moment';
import * as _ from 'lodash';

import { Log, IDateRangePickerOptions, ComponentDefinition, IDatePickerDates } from '../../../models';
import { IDateHelperFormatService, ILogService } from '../../../services';

class LogsStateController implements angular.IComponentController {
    dates: IDatePickerDates;
    isLoading: boolean;
    logs: Log[];
    options: IDateRangePickerOptions;

    static $inject = [
        '$timeout',
        'dateHelperFormatService',
        'logService'
    ];

    constructor(
        private _$timeout: angular.ITimeoutService,
        private _dateHelperFormatService: IDateHelperFormatService,
        private _logService: ILogService) {
    }

    $onInit() {
        const now = moment().millisecond(0);
        this.dates = {
            startDate: now.clone().add(-1, 'h'),
            endDate: now
        };
        this.options = {
            applyClass: 'btn-primary',
            timePicker24Hour: true,
            timePicker: true,
            alwaysShowCalendars: true,
            showDropdowns: true,
            locale: {
                applyLabel: 'Refresh',
                fromLabel: 'Start date',
                format: this._dateHelperFormatService.getDateFormat(),
                toLabel: 'End date',
                cancelLabel: 'Cancel',
                customRangeLabel: 'Custom range',
                firstDay: 0
            },
            ranges: this.buildRanges()
        };
    }

    onRangeChange(beginDate: moment.Moment, endDate: moment.Moment): void {
        if (beginDate.isSame(endDate)) {
            endDate = endDate.add(1, 'm');
            this._$timeout(() => {
                this.dates = { startDate: beginDate, endDate: endDate };
            });
        }
        this.refresh(beginDate.toISOString(), endDate.toISOString());
    }

    onRefresh() {
        this.refresh(this.dates.startDate.toISOString(), this.dates.endDate.toISOString());
    }

    download() {
        this._logService
            .download()
            .then(d => window.open(d, '_self'));
    }

    private buildRanges(): { [label: string]: [moment.Moment, moment.Moment] } {
        return {
            'Last 5 minutes': [moment().add(-5, 'm'), moment()],
            'Last 15 minutes': [moment().add(-15, 'm'), moment()],
            'Last hour': [moment().add(-1, 'h'), moment()]
        };
    }

    private findRange(value: [string, string]): string {
        if (this.options?.ranges) {
            const values: [moment.Moment, moment.Moment][] = _.values(this.options.ranges) as [moment.Moment, moment.Moment][];
            const keys = Object.keys(this.options.ranges);
            const found = _.findIndex(values, v => v[0].toISOString() === value[0] && v[1].toISOString() === value[1]);
            return found >= 0 ? keys[found] : '';
        }
    }

    private refresh(beginDate?: string, endDate?: string) {
        if (!beginDate && !endDate) {
            beginDate = this.dates.startDate.toISOString();
            endDate = this.dates.endDate.toISOString();
        }
        this.isLoading = true;
        const found = this.findRange([beginDate, endDate]);
        if (found) {
            const range = this.buildRanges()[found];
            beginDate = range[0].toISOString();
            endDate = range[1].toISOString();
            this.dates = {
                startDate: range[0],
                endDate: range[1]
            };
        }
        this._logService
            .getBetween(beginDate, endDate)
            .then(data => {
                data.forEach(element => {
                    element.moment = moment(element.timestamp);
                });
                this.logs = data;
            })
            .finally(() => this.isLoading = false);
    }
}

export const logsState: ComponentDefinition = {
    componentId: 'wtLogsState',
    controller: LogsStateController,
    controllerAs: 'vm',
    template: require('./logsState.component.html'),
    bindings: {
    }
};